"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardServiceImpl = void 0;
var DashboardProviderImpl_1 = require("./provider/firebase/DashboardProviderImpl");
var DashboardProviderImpl_2 = require("./provider/airabbi/DashboardProviderImpl");
var DashboardServiceImpl = (function () {
    function DashboardServiceImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.getAllUsers = function () { return _this.provider.getAllUsers(); };
        this.getUnitCourses = function (unit) { return _this.provider.getUnitCourses(unit); };
        this.getUnitExercises = function (unit) { return _this.provider.getUnitExercises(unit); };
        this.getKernels = function (isDesktop) { return _this.provider.getKernels(isDesktop); };
        this.getActiveUsers = function (beginTime, endTime) {
            return _this.provider.getActiveUsers(beginTime, endTime);
        };
        this.getCodeSubmits = function (data) { return _this.provider.getCodeSubmits(data); };
        this.getCourseRegistrations = function (data) {
            return _this.provider.getCourseRegistrations(data);
        };
        this.getEvents = function (data) { return _this.provider.getEvents(data); };
        this.getUserActiveHistory = function (data) {
            return _this.provider.getUserActiveHistory(data);
        };
        this.stopAllMonitor = function () { return _this.provider.stopAllMonitor(); };
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new DashboardProviderImpl_1.DashboardProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new DashboardProviderImpl_2.DashboardProviderImpl(cfg);
                break;
        }
    }
    DashboardServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    DashboardServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        return this.provider.setDebuggable(debuggable);
    };
    DashboardServiceImpl.prototype.countData = function (queryData) {
        return this.provider.countData(queryData);
    };
    DashboardServiceImpl.prototype.getGeneralData = function (collection, filter, projection, sort, distinctKey, skip, limit) {
        return this.provider.getGeneralData(collection, filter, projection, sort, distinctKey, skip, limit);
    };
    return DashboardServiceImpl;
}());
exports.DashboardServiceImpl = DashboardServiceImpl;
//# sourceMappingURL=DashboardServiceImpl.js.map